import AppDispatcher from '../dispatcher/AppDispatcher';
import {
  DISMISS_LAST_LOGIN_ALERT,
  INIT_LAST_LOGIN_ALERT,
  INIT_LAST_LOGIN_ALERT_ERROR,
  INIT_LAST_LOGIN_ALERT_SUCCESS,
  REQUEST_LAST_LOGIN_DETAILS,
  REQUEST_LAST_LOGIN_DETAILS_ERROR,
  REQUEST_LAST_LOGIN_DETAILS_SUCCESS,
} from '../constants/LastLoginConstants';

export const initLastLoginAlert = () => {
  AppDispatcher.handleViewAction({
    actionType: INIT_LAST_LOGIN_ALERT,
  });
};

export const handleLastLoginAlertSuccess = (response) => {
  AppDispatcher.handleViewAction({
    actionType: INIT_LAST_LOGIN_ALERT_SUCCESS,
    data: response,
  });
};

export const handleLastLoginAlertError = (response) => {
  AppDispatcher.handleViewAction({
    actionType: INIT_LAST_LOGIN_ALERT_ERROR,
    data: response,
  });
};

export const requestLastLoginDetails = () => {
  AppDispatcher.handleViewAction({
    actionType: REQUEST_LAST_LOGIN_DETAILS,
  });
};

export const handleLastLoginDetailsSuccess = (response) => {
  AppDispatcher.handleViewAction({
    actionType: REQUEST_LAST_LOGIN_DETAILS_SUCCESS,
    data: response,
  });
};

export const handleLastLoginDetailsError = (response) => {
  AppDispatcher.handleViewAction({
    actionType: REQUEST_LAST_LOGIN_DETAILS_ERROR,
    data: response,
  });
};

export const dismissLastLoginAlert = () => {
  AppDispatcher.handleViewAction({
    actionType: DISMISS_LAST_LOGIN_ALERT,
  });
};
